import React, { FC } from 'react'
import * as Components from './components'
import { CMSStaticSection } from '../models'
import './JCMSStaticSections.scss'
import { JSectionsWrapper } from '../JSectionsWrapper'


export interface JCMSStaticSectionsExposedComp {
    Banner: React.ComponentType<Components.JCMSStaticBannerProps>
    Content: React.ComponentType<Components.JCMSStaticContentProps>
    HowToTemplate: React.ComponentType<Components.JCMSStaticHowToProps>
    FaqTemplate: React.ComponentType<Components.JCMSStaticFaqTemplateProps>
    Slider: React.ComponentType<Components.JCMSStaticSliderProps>
    Card: React.ComponentType<Components.JCMSStaticCardProps>
    Modal: React.ComponentType<Components.JCMSStaticModalProps>
}
export interface JCMSStaticSectionsProps {
    sections: CMSStaticSection.Content[]
}
export const JCMSStaticSections: FC<JCMSStaticSectionsProps> & JCMSStaticSectionsExposedComp = props => {

    if (!props.sections?.length) return <></>

    return (
        <JSectionsWrapper>
            {
                props.sections.filter(CMSStaticSection.isStaticContent).map((section, i) => (
                    <JCMSStaticSections.Content {...section} key={i} />
                ))
            }
        </JSectionsWrapper>
    )
}



JCMSStaticSections.Banner = Components.JCMSStaticBanner
JCMSStaticSections.Content = Components.JCMSStaticContent
JCMSStaticSections.Slider = Components.JCMSStaticSlider
JCMSStaticSections.Card = Components.JCMSStaticCard
JCMSStaticSections.Modal = Components.JCMSStaticModal
JCMSStaticSections.HowToTemplate = Components.JCMSStaticHowTo
JCMSStaticSections.FaqTemplate = Components.JCMSStaticFaqTemplate